import { type ReactNode } from 'react';

export interface HeroProps {
    eyebrow: string;
    title: ReactNode;
    lead: string;
    cta: ReactNode;
    chips?: readonly string[];
    /** Use the left-aligned hero variant (download page style). */
    variant?: 'center' | 'left';
}

/** Marketing page hero section: eyebrow, h1, lead paragraph, CTA, optional chip list. */
export function Hero({ eyebrow, title, lead, cta, chips, variant = 'center' }: HeroProps) {
    const sectionClass = variant === 'left' ? 'mktg-hero mktg-hero--left' : 'mktg-hero';
    return (
        <section className={sectionClass}>
            <div className="mktg-container">
                <p className="mktg-eyebrow">{eyebrow}</p>
                <h1 className="mktg-hero__title">{title}</h1>
                <p className="mktg-hero__lead">{lead}</p>
                <div className="mktg-hero__cta">{cta}</div>
                {chips && chips.length > 0 && (
                    <ul className="mktg-chips" aria-label="Feature highlights">
                        {chips.map((chip) => (
                            <li key={chip} className="mktg-chip">{chip}</li>
                        ))}
                    </ul>
                )}
            </div>
        </section>
    );
}
